import { LoggingService } from "./loggingSvc";

export class DeprecationService {
  private deprecationKeyMap = new Set();
  // @ngInject
  constructor(private loggingService: LoggingService) {}

  public logDeprecationMessage(message: string): void {
    if (!this.deprecationKeyMap.has(message)) {
      this.deprecationKeyMap.add(message);
      this.loggingService.logWarning(`This feature is deprecated. ${message} `);
    }
  }
}
